import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconView = props => (
  <SvgIcon {...props} viewBox="0 0 16 12">
    <path d="m8 0c-3.6364 0-6.7418 2.488-8 6 1.2582 3.512 4.3636 6 8 6 3.636 0 6.742-2.488 8-6-1.258-3.512-4.364-6-8-6zm0 10c-2.208 0-4-1.792-4-4s1.792-4 4-4 4 1.792 4 4-1.792 4-4 4zm0-6c-1.1067 0-2 0.8933-2 2s0.8933 2 2 2 2-0.8933 2-2-0.8933-2-2-2z" />
  </SvgIcon>
);

export default IconView;



// WEBPACK FOOTER //
// ./src/components/icons/IconView.js